function About() {
  return (
    <div className="page">
      <h1>About Me</h1>
      <p>
        I am currently pursuing B-Tech in Information Technology.
        I enjoy solving problems and building real-world projects
        using React and Python.
      </p>

      <h3>Skills</h3>
      <ul>
        <li>Languages: C, C++, Python</li>
        <li>HTML, CSS, JavaScript</li>
        <li>React.js</li>
        <li>DBMS</li>
      </ul>
    </div>
  );
}

export default About;